import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MapPin, ShieldCheck, Clock, Wrench, ArrowRight } from "lucide-react";
export default function PatioDoorRepairServicesInLongueuil() {
  const features = [{
    icon: <Clock className="size-5 text-accent" />,
    title: "Բարձր Ճշգրտություն",
    desc: "Ժամանակակից սարքավորումների կիրառում"
  }, {
    icon: <ShieldCheck className="size-5 text-accent" />,
    title: "Լիցենզավորված Ծառայություն",
    desc: "Պետական չափանիշներին համապատասխան"
  }, {
    icon: <Wrench className="size-5 text-accent" />,
    title: "Տեխնիկական Աջակցություն",
    desc: "Ամբողջական փաստաթղթավորում"
  }];
  return;
}